import Types from './Types'

// Action Creators

const loginUser = (payload, persistent) => ({
    type: Types.LOGIN_USER,
    payload,
    persistent
})

const loginResponse = (response) => ({
    type: Types.LOGIN_RESPONSE,
    response
})

const logoutUser = () => ({
    type: Types.LOGOUT_USER
})

const loginUsingMagicLink = (magicLink) => ({
    type: Types.LOGIN_USING_MAGIC_LINK,
    magicLink
})

const loginResponseMagicLink = (magicLink) => ({
    type: Types.LOGIN_RESPONSE_MAGIC_LINK,
    magicLink
})

const resetOrganization = () => ({
    type: Types.RESET_ORG
})

const resetStudent = () => ({
    type: Types.RESET_STUDENT
})

const getOrganization = (orgId) => ({
    type: Types.GET_ORGANIZATION,
    orgId
})

const storeOrganization = (organization) => ({
    type: Types.STORE_ORGANIZATION,
    organization
})

const updateOrganization = (organizationId, organizationData) => ({
    type: Types.PUT_ORGANIZATION,
    organizationId,
    organizationData
})

const storeOrgClasses = (classes) => ({
    type: Types.STORE_CLASSES,
    classes
})

const initializeForm = (formData) => ({
    type: Types.INITIALIZE_FORM,
    formData
})

const fetchStudentList = payload => ({
    type: Types.FETCH_STUDENT_LIST,
    payload
})

const storeStudentList = payload => ({
    type: Types.STORE_STUDENT_LIST,
    payload
})

const getProgramByOrganization = organization_id => ({
    type: Types.GET_PROGRAM_BY_ORGANIZATION,
    organization_id
})

const storeProgramList = (payload) => ({
    type: Types.STORE_PROGRAM_LIST,
    payload
})

const getReport = (reportType, config) => ({
    type: Types.GET_REPORT,
    reportType,
    config
})

const loadReport = (report) => ({
    type: Types.LOAD_REPORT,
    report
})

const getStudentReport = (reportType, config) => ({
    type: Types.GET_STUDENT_REPORT,
    reportType,
    config
})

const loadStudentReport = (report) => ({
    type: Types.LOAD_STUDENT_REPORT,
    report
})

const getBulkStudentReport = (reportType, config) => ({
    type: Types.GET_BULK_STUDENT_REPORT,
    reportType,
    config
})

const setLoader = (message) => ({
    type: Types.SET_LOADER,
    message
})

const unsetLoader = () => ({
    type: Types.UNSET_LOADER
})

const fetchAllDocs = (contentId, fileGroup = "school") => ({
    type: Types.FETCH_ALL_DOCS,
    contentId,
    fileGroup
})

const updateDocs = (reqDocs, fileGroup = "school") => ({
    type: Types.UPDATE_DOCS,
    reqDocs,
    fileGroup
})

const removeDoc = (id, targetID, srcID, category, fileGroup = "school") => ({
    type: Types.REMOVE_DOC,
    id,
    targetID,
    srcID,
    category,
    fileGroup
})

const onFileSubmit = (fileObj, contentId, category, fileGroup = "school") => ({
    type: Types.UPLOAD_FILE,
    fileObj,
    contentId,
    category,
    fileGroup
})

const addContentID = (contentId, fileGroup) => ({
    type: Types.ADD_SCHOOL_CONTENT_ID,
    contentId,
    fileGroup
})

const getGlossary = () => ({
    type: Types.GET_GLOSSARY
})

const storeGlossary = (payload, error) => ({
    type: Types.STORE_GLOSSARY,
    payload,
    error
})

const changePassword = (password) => ({
    type: Types.CHANGE_PASSWORD,
    password
})

const fetchOverViewReport = (startNode) => ({
    type: Types.FETCH_OVERVIEW_REPORT,
    startNode
})

const storeOverViewReport = (overViewReport) => ({
    type: Types.STORE_OVERVIEW_REPORT,
    overViewReport
})

const getDMFTIndex = (studentId, startNodeId) => ({
    type: Types.GET_DMFT_INDEX,
    studentId,
    startNodeId
})

const updateDMFTIndex = (dmftIndex) => ({
    type: Types.UPDATE_DMFT_INDEX,
    dmftIndex
})

const changeReportInReducer = (billingId) => ({
    type: Types.CHANGE_REPORT_IN_REDUCER,
    billingId
})

const fetchCustomStudentList = (payload, hideLoader) => ({
    type: Types.FETCH_CUSTOM_STUDENT_LIST,
    payload,
    hideLoader
})

const getSchoolClasses = (organization_id) => ({
    type: Types.GET_SCHOOL_CLASSES,
    organization_id
})

const addStudentMedicalInfo = (uuid, custom) => ({
    type: Types.ADD_STUDENT_MEDICAL_INFO,
    uuid,
    custom
})

const postStudentEpisodeInfo = (studentId, customJson, episodeType) => ({
    type: Types.POST_STUDENT_EPISODE_INFO,
    studentId,
    customJson,
    episodeType
})

const toggleDataUpdateFlag = () => ({
    type: Types.TOGGLE_DATA_UPDATE_FLAG
})

const fetchStudentEpisodeSearch = (header) => ({
    type: Types.FETCH_STUDENT_EPISODE_SEARCH,
    header  
})

const storeStudentEpisodeSearch = (payload) => ({
    type: Types.STORE_STUDENT_EPISODE_SEARCH,
    payload
})

const fetchClinicStudentSearch = (header) => ({
    type: Types.FETCH_CLINIC_STUDENT_SEARCH,
    header  
})

const storeClinicStudentSearch = (payload) => ({
    type: Types.STORE_CLINIC_STUDENT_SEARCH,
    payload
})

const fetchClinicEpisodeStats = (inOrganizationId) => ({
    type: Types.FETCH_CLINIC_EPISODE_STATS,
    inOrganizationId
})

const storeClinicEpisodeStats = (payload) => ({
    type: Types.STORE_CLINIC_EPISODE_STATS,
    payload
})

const fetchNurseMeta = () => ({
    type: Types.FETCH_NURSE_META
})

const storeNurseMeta = (response) => ({
    type: Types.STORE_NURSE_META,
    response: {...response}
})

const getStudentBoardingType = (organizationId) => ({
    type: Types.GET_STUDENT_BOARDING_TYPE,
    organizationId
})

const storeStudentBoardingType = (response) => ({
    type: Types.STORE_STUDENT_BOARDING_TYPE,
    response
})

export default {

    getStudentBoardingType,
    storeStudentBoardingType,
    
    fetchNurseMeta,
    storeNurseMeta,

    loginUsingMagicLink,
    loginResponseMagicLink,

    fetchClinicEpisodeStats,
    storeClinicEpisodeStats,

    fetchClinicStudentSearch,
    storeClinicStudentSearch,

    fetchStudentEpisodeSearch,
    storeStudentEpisodeSearch,
    
    addContentID,
    postStudentEpisodeInfo,
    addStudentMedicalInfo,

    toggleDataUpdateFlag,
    
    getSchoolClasses,

    fetchCustomStudentList,

    loginUser,
    loginResponse,
    logoutUser,
    changePassword,

    initializeForm,
    fetchStudentList,
    storeStudentList,

    getOrganization,
    storeOrganization,
    updateOrganization,

    storeOrgClasses,
    getProgramByOrganization,
    storeProgramList,

    getReport,
    loadReport,

    getStudentReport,
    loadStudentReport,
    getBulkStudentReport,

    getDMFTIndex,
    updateDMFTIndex,

    setLoader,
    unsetLoader,

    resetOrganization,
    resetStudent,

    fetchAllDocs,
    updateDocs,
    removeDoc,
    onFileSubmit,

    getGlossary,
    storeGlossary,

    storeOverViewReport,
    fetchOverViewReport,
    changeReportInReducer
}


// WEBPACK FOOTER //
// ./src/Actions/Creators.js